<template>
  <section class="sec" id="opensource">
    <div class="sec-inner">
      <div class="sec-head">
        <div class="sec-eyebrow">开源</div>
        <h2 class="sec-title">开源项目</h2>
        <p class="sec-sub">
          日常在用的小工具与实验性项目，全部开源，欢迎取用。
        </p>
      </div>

      <div class="os-list">
        <a
          v-for="p in projects"
          :key="p.name"
          class="os-row"
          :href="p.link"
          target="_blank"
          rel="noopener"
        >
          <div class="os-main">
            <div class="os-name">
              {{ p.name }}
              <span class="os-lang">{{ p.lang }}</span>
            </div>
            <div class="os-desc">{{ p.desc }}</div>
          </div>
          <div class="os-stars" v-if="p.stars">{{ p.stars }} star</div>
        </a>
      </div>

      <div class="sec-more">
        <a class="more-link" :href="profile.github" target="_blank" rel="noopener">
          GitHub 上还有更多 &rarr;
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import { openSource, profile } from "@/assets/js/profile";

export default {
  name: "OpenSourceSection",
  data() {
    return { projects: openSource, profile };
  }
};
</script>

<style scoped>
.sec-head {
  margin-bottom: 40px;
}
.os-list {
  border-top: 1px solid var(--border);
}
.os-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 4px;
  border-bottom: 1px solid var(--border);
  transition: background 0.18s ease, padding-left 0.18s ease;
}
.os-row:hover {
  background: rgba(217, 119, 87, 0.05);
  padding-left: 12px;
}
.os-main {
  flex: 1 1 auto;
  padding-right: 24px;
  min-width: 0;
}
.os-name {
  font-size: 16.5px;
  font-weight: 600;
  color: var(--ink);
  margin-bottom: 6px;
}
.os-row:hover .os-name {
  color: var(--accent);
}
.os-lang {
  font-size: 12px;
  font-weight: 400;
  color: var(--ink-faint);
  background: var(--bg-alt);
  border-radius: 4px;
  padding: 2px 8px;
  margin-left: 10px;
  vertical-align: 2px;
}
.os-desc {
  font-size: 14px;
  line-height: 1.75;
  color: var(--ink-soft);
}
.os-stars {
  flex: 0 0 auto;
  font-size: 13px;
  color: var(--ink-faint);
  white-space: nowrap;
}
.sec-more {
  margin-top: 30px;
}
.more-link {
  font-size: 15px;
  color: var(--accent);
  font-weight: 500;
}

@media (max-width: 760px) {
  .os-row {
    flex-direction: column;
    align-items: flex-start;
  }
  .os-main {
    padding-right: 0;
  }
  .os-stars {
    margin-top: 8px;
  }
}
</style>
